import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { getRouteStackPath } from '@portal/config/routes';
import PanelContent from '~/components/PanelContent/PanelContent';
import { translate } from '~/services/i18n';
import AccountSplit from './AccountSplit';

const AccountSplitNavigationStack = () => {
  return (
    <Switch>
      <Route
        exact
        path={getRouteStackPath('ACCOUNT_SPLIT', 'ACCOUNT_SPLIT_PAGE')}
      >
        <PanelContent
          pageTitle={translate('PAGES.ACCOUNT_SPLIT.TITLE')}
          pageDescription={translate('PAGES.ACCOUNT_SPLIT.DESCRIPTION')}
        >
          <AccountSplit />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default AccountSplitNavigationStack;
